class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById(this.matches('cart-drawer-items') ? 'CartDrawer-LineItemStatus' : 'shopping-cart-line-item-status');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));

    const cartItemsSum = document.querySelectorAll('.drawer__cart-items-wrapper .quantity__input[type="number"]');
    let totalcartItemsSum = 0;
    cartItemsSum.forEach(input => totalcartItemsSum += Number(input.value));
    const updateCartQuantityIcon = document.querySelector('.totals__items');
    if (updateCartQuantityIcon) {
      updateCartQuantityIcon.textContent = totalcartItemsSum;
    }
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    if (!event.target.matches('.quantity__input[data-index]')) return;
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement?.getAttribute('name'));
  }

  onCartUpdate() {
    return fetch(`${routes.cart_url}?section_id=main-cart-items`)
      .then((response) => response.text())
      .then((responseText) => this.renderSection(responseText))
      .catch((e) => {
        console.error(e);
      });
  }

  renderSection(responseText) {
    const html = new DOMParser().parseFromString(responseText, 'text/html');
    const sourceQty = html.querySelector('cart-items');
    if (sourceQty) {
      this.innerHTML = sourceQty.innerHTML;
      this.classList.toggle('is-empty', sourceQty.classList.contains('is-empty'));
    }
    const footer = document.getElementById('main-cart-footer');
    const nextFooter = html.getElementById('main-cart-footer');
    if (footer && nextFooter) {
      footer.innerHTML = nextFooter.innerHTML;
      footer.classList.toggle('is-empty', nextFooter.classList.contains('is-empty'));
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents-items',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
    const finishMutation = window.IngenioCartRestore?.beginMutation?.();

    const cartKey = this.querySelector(`[data-index="${line}"][data-cart-key]`)?.dataset.cartKey;
    const body = JSON.stringify({
      ...(cartKey ? { id: cartKey } : { line }),
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`${this.matches('cart-drawer-items') ? 'Drawer-quantity' : 'Quantity'}-${line}`);
        const items = this.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);

        const cartTitle = this.parentNode.querySelector('.cart-title');
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const activeDrawer = this.matches('cart-drawer-items') && cartDrawerWrapper?.classList.contains('active');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartTitle) {
          cartTitle.classList.toggle('is-empty', parsedState.item_count === 0);
        }
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          let getSectionId = document.getElementById(section.id);
          if (getSectionId != null && parsedState.sections?.[section.section]) {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';

        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }

        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`${this.matches('cart-drawer-items') ? 'CartDrawer-Item' : 'CartItem'}-${line}`);

        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          activeDrawer
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && activeDrawer) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (cartDrawerWrapper?.querySelector('.cart-item') && activeDrawer) {
          trapFocus(cartDrawerWrapper, cartDrawerWrapper.querySelector('.cart-item__name'));
        }
        const renderedSections = this.getSectionsToRender().map((section) => section.section);
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: this.matches('cart-drawer-items') ? 'cart-drawer-items' : 'cart-items',
          renderedSections,
          cartData: parsedState,
        });
        if (renderedSections.includes('cart-drawer')) {
          if (cartDrawerWrapper) cartDrawerWrapper.dataset.cartItemCount = String(parsedState.item_count);
          document.dispatchEvent(new CustomEvent('ingenio:cart-drawer-rendered', { detail: { itemCount: parsedState.item_count } }));
        }

        const updateCartQuantityIconQ = document.querySelector('.totals__items');
        if (updateCartQuantityIconQ) {
          updateCartQuantityIconQ.textContent = parsedState.item_count;
        }

      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById(this.matches('cart-drawer-items') ? 'CartDrawer-CartErrors' : 'cart-errors');
        if (errors) errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        finishMutation?.();
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`${this.matches('cart-drawer-items') ? 'CartDrawer-LineItemError' : 'Line-item-error'}-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement = document.getElementById(this.matches('cart-drawer-items') ? 'CartDrawer-LineItemStatus' : 'shopping-cart-line-item-status');
    this.lineItemStatusElement?.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById(this.matches('cart-drawer-items') ? 'CartDrawer-LiveRegionText' : 'cart-live-region-text');
    cartStatus?.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus?.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById(this.matches('cart-drawer-items') ? 'CartDrawer-CartItems' : 'main-cart-items');
    mainCartItems?.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement?.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById(this.matches('cart-drawer-items') ? 'CartDrawer-CartItems' : 'main-cart-items');
    mainCartItems?.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!window.IngenioCartNote) {
  const fields = new Set();
  let initialized = false;
  let value = '';
  let savedValue = '';
  let timer;
  let saving = null;
  let status = '';
  let error = '';

  const notify = () => fields.forEach((field) => field.renderNoteState({ value, status, error }));
  const hasPending = () => Boolean(saving || value !== savedValue);
  const flush = () => {
    clearTimeout(timer);
    if (saving) return saving;
    if (value === savedValue) {
      error = '';
      if (status) status = 'saved';
      notify();
      return Promise.resolve();
    }
    status = 'saving';
    error = '';
    notify();
    const finishMutation = window.IngenioCartRestore?.beginMutation?.();
    saving = (async () => {
      while (value !== savedValue) {
        const submittedValue = value;
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 12000);
        try {
          const response = await fetch(routes.cart_update_url, {
            ...fetchConfig(),
            body: JSON.stringify({ note: submittedValue }),
            signal: controller.signal,
          });
          const cart = await response.json();
          if (!response.ok || cart.errors || String(cart.note || '') !== submittedValue) {
            throw new Error('No se pudo confirmar el guardado de la nota.');
          }
          savedValue = submittedValue;
        } finally {
          clearTimeout(timeout);
        }
      }
      status = 'saved';
    })().catch(() => {
      status = 'error';
      error = 'No pudimos guardar la nota. Reintenta antes de continuar al pago.';
      throw new Error(error);
    }).finally(() => {
      saving = null;
      finishMutation?.();
      notify();
    });
    return saving;
  };

  window.IngenioCartNote = {
    register(field) {
      if (!initialized) {
        value = savedValue = field.textarea.value;
        initialized = true;
      }
      fields.add(field);
      notify();
    },
    unregister(field) { fields.delete(field); },
    reconcile(serverValue) {
      if (hasPending()) return;
      value = savedValue = String(serverValue || '');
      initialized = true;
      status = '';
      error = '';
      notify();
    },
    edit(nextValue) {
      value = nextValue;
      error = '';
      status = value === savedValue && !saving ? '' : 'saving';
      notify();
      clearTimeout(timer);
      timer = setTimeout(() => flush().catch(() => {}), ON_CHANGE_DEBOUNCE_TIMER);
    },
    hasPending,
    flush,
    showError(form) {
      const field = [...fields].find((item) => item.textarea.form === form) || [...fields][0];
      if (!field) return;
      const details = field.closest('details');
      if (details) {
        details.open = true;
        details.querySelector('summary')?.setAttribute('aria-expanded', 'true');
      }
      field.retryButton?.focus();
    },
  };

  const submissions = new Set();
  let pendingLink = false;
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!['cart', 'CartDrawer-Form'].includes(form.id) || event.submitter?.name !== 'checkout' || !hasPending()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (submissions.size || pendingLink) return;
    submissions.add(form.id);
    const submitter = event.submitter;
    submitter.setAttribute('aria-busy', 'true');
    try {
      await flush();
      const currentForm = document.getElementById(form.id);
      if (!currentForm) return;
      const currentSubmitter = submitter.isConnected ? submitter : [...currentForm.elements].find((element) => element.name === 'checkout');
      submissions.delete(form.id);
      if (currentSubmitter) currentForm.requestSubmit(currentSubmitter);
    } catch (_) {
      window.IngenioCartNote.showError(document.getElementById(form.id) || form);
    } finally {
      submitter.removeAttribute('aria-busy');
      submissions.delete(form.id);
    }
  }, true);

  document.addEventListener('click', async (event) => {
    const link = event.target.closest('a[href]');
    if (!link || !hasPending() || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target || link.hasAttribute('download')) return;
    if (!link.closest('cart-drawer, cart-items, #main-cart-footer, .ingenio-cart-page')) return;
    const url = new URL(link.href, window.location.href);
    if (!['http:', 'https:'].includes(url.protocol) || (url.pathname === window.location.pathname && url.hash)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pendingLink || submissions.size) return;
    pendingLink = true;
    link.setAttribute('aria-busy', 'true');
    try {
      await flush();
      window.location.assign(url.href);
    } catch (_) {
      const form = document.getElementById(link.closest('cart-drawer') ? 'CartDrawer-Form' : 'cart');
      window.IngenioCartNote.showError(form);
    } finally {
      pendingLink = false;
      link.removeAttribute('aria-busy');
    }
  }, true);
}

// A restored page can contain an old cart after a customer returns from checkout.
// Refresh its existing surfaces without opening the drawer or replaying an add event.
if (!window.IngenioCartRestore) {
  let pending = null;
  let revision = 0;
  let needsRefresh = false;
  const mutations = new Set();
  const idleWaiters = new Set();

  subscribe(PUB_SUB_EVENTS.cartUpdate, () => { revision += 1; });

  const beginMutation = () => {
    const token = {};
    mutations.add(token);
    revision += 1;
    return () => {
      if (!mutations.delete(token)) return;
      revision += 1;
      if (mutations.size === 0) {
        idleWaiters.forEach((resolve) => resolve());
        idleWaiters.clear();
      }
    };
  };
  const waitForIdle = async () => {
    while (mutations.size) {
      await new Promise((resolve) => idleWaiters.add(resolve));
    }
  };

  const refresh = () => {
    if (pending) return pending;
    needsRefresh = true;
    pending = (async () => {
      while (needsRefresh) {
        // Do not replace controls (or their errors) while an add, quantity change
        // or note save is still pending, even before it publishes cartUpdate.
        await waitForIdle();
        if (mutations.size) continue;
        const requestedRevision = revision;
        const drawerElement = document.querySelector('cart-drawer');
        const drawer = typeof drawerElement?.renderContents === 'function' ? drawerElement : null;
        const page = document.querySelector('cart-items.main-cart-page');
        const pageSection = page && (document.getElementById('main-cart-items')?.dataset.id || 'main-cart-items');
        const sectionIds = new Set(drawer?.getSectionsToRender().map((section) => section.id) || ['cart-icon-bubble', 'cart-icon-bubble-sticky']);
        if (pageSection) sectionIds.add(pageSection);
        const cartUrl = window.routes?.cart_url || routes.cart_url;
        const sectionsUrl = new URL(cartUrl, window.location.origin);
        sectionsUrl.searchParams.set('sections', [...sectionIds].join(','));
        const requestJson = async (url) => {
          const response = await fetch(url, { cache: 'no-store' });
          if (!response.ok) throw new Error('No se pudo actualizar el carrito.');
          return response.json();
        };
        const [cart, sections] = await Promise.all([
          requestJson(`${cartUrl}.js`),
          requestJson(sectionsUrl.href),
        ]);
        // A write started or finished during the snapshot. Wait for idle and
        // fetch once more, never applying data from before that operation.
        if (mutations.size || revision !== requestedRevision) continue;
        if (typeof cart.item_count !== 'number' || !sections || [...sectionIds].some((id) => !sections[id])) {
          throw new Error('La respuesta del carrito está incompleta.');
        }
        window.IngenioCartNote?.reconcile(cart.note);
        if (drawer) {
          drawer.renderContents({ ...cart, sections }, { open: false });
        } else {
          ['cart-icon-bubble', 'cart-icon-bubble-sticky'].forEach((id) => {
            const target = document.getElementById(id);
            const source = new DOMParser().parseFromString(sections[id], 'text/html').querySelector('.shopify-section');
            if (target && source) target.innerHTML = source.innerHTML;
          });
        }
        if (page && sections[pageSection]) page.renderSection(sections[pageSection]);
        needsRefresh = false;
      }
    })().catch((error) => {
      console.error('Cart restore:', error);
      ['cart-errors', 'CartDrawer-CartErrors'].forEach((id) => {
        const target = document.getElementById(id);
        if (!target) return;
        target.setAttribute('role', 'alert');
        target.textContent = window.cartStrings?.restorationError || 'No pudimos actualizar tu carrito. Revisa tu conexión y recarga la página antes de continuar al pago.';
      });
    }).finally(() => {
      pending = null;
    });
    return pending;
  };

  window.IngenioCartRestore = { refresh, beginMutation };
  window.addEventListener('pageshow', (event) => {
    const navigation = performance.getEntriesByType('navigation')[0];
    if (event.persisted || navigation?.type === 'back_forward') refresh();
  });
  window.addEventListener('online', () => {
    if (needsRefresh) refresh();
  });
}

if (!customElements.get('cart-note')) {
  let noteCount = 0;
  customElements.define('cart-note', class CartNote extends HTMLElement {
    connectedCallback() {
      this.textarea = this.querySelector('textarea[name="note"]');
      if (!this.textarea) return;
      this.statusElement = this.querySelector('[data-cart-note-status]');
      if (!this.statusElement) {
        this.statusElement = document.createElement('p');
        this.statusElement.dataset.cartNoteStatus = '';
        this.statusElement.setAttribute('role', 'status');
        this.statusElement.setAttribute('aria-live', 'polite');
        this.append(this.statusElement);
      }
      if (!this.statusElement.id) this.statusElement.id = `CartNoteStatus-${++noteCount}`;
      const describedBy = new Set((this.textarea.getAttribute('aria-describedby') || '').split(' ').filter(Boolean));
      describedBy.add(this.statusElement.id);
      this.textarea.setAttribute('aria-describedby', [...describedBy].join(' '));
      this.retryButton = this.querySelector('[data-cart-note-retry]');
      if (!this.retryButton) {
        this.retryButton = document.createElement('button');
        this.retryButton.type = 'button';
        this.retryButton.dataset.cartNoteRetry = '';
        this.retryButton.textContent = this.dataset.noteRetry || 'Reintentar guardado';
        this.append(this.retryButton);
      }
      this.onInput = () => window.IngenioCartNote.edit(this.textarea.value);
      this.onRetry = () => window.IngenioCartNote.flush().then(() => this.textarea.focus()).catch(() => {});
      this.textarea.addEventListener('input', this.onInput);
      this.retryButton.addEventListener('click', this.onRetry);
      window.IngenioCartNote.register(this);
    }

    disconnectedCallback() {
      this.textarea?.removeEventListener('input', this.onInput);
      this.retryButton?.removeEventListener('click', this.onRetry);
      window.IngenioCartNote.unregister(this);
    }

    renderNoteState({ value, status, error }) {
      if (this.textarea.value !== value) this.textarea.value = value;
      this.dataset.noteState = status;
      this.statusElement.textContent = error
        ? (this.dataset.noteError || error)
        : status === 'saving' ? (this.dataset.noteSaving || 'Guardando nota…')
        : status === 'saved' ? (this.dataset.noteSaved || 'Nota guardada') : '';
      this.retryButton.hidden = !error;
      this.textarea.setAttribute('aria-invalid', String(Boolean(error)));
    }
  });
}

